import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { VideosData } from "../types";
import { useNavigate } from "react-router-dom";
import AspectAwareContainer from "./AspectAwareContainer";
import { dateRepresent } from "../helpers";

function Video(props: { video: VideosData; onSelect?: () => void }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (props.onSelect) props.onSelect(); // CLoses the AppbarSearchDialog
    navigate(`/videos/${props.video.id}`);
  };

  return (
    <Stack
      onClick={handleClick}
      direction={"column"}
      sx={{
        borderRadius: 3,
        "&:hover": {
          bgcolor: "action.hover",
          cursor: "pointer",
        },
      }}
    >
      <AspectAwareContainer video={props.video} isRelatedVideos />
      <VideoDescription video={props.video} date />
    </Stack>
  );
}

export function VideoDescription(props: {
  big?: boolean;
  date?: boolean;
  video: VideosData;
}) {
  const { date, time } = dateRepresent(props.video.created_at);
  return (
    <Stack
      direction={"row"}
      spacing={2}
      sx={{
        alignItems: "flex-start",
        justifyContent: "space-between",
        p: props?.big ? 0 : 1
      }}>
      <Stack>
        {/* title */}
        <Box>
          <Typography
            variant={props.big ? "h6" : "subtitle1"}
            component="div"
            sx={{
              fontWeight: 800,
              lineHeight: 1.2
            }}>
            {props.video.title}{" "}
            {props.video.for_internal_use && (
              <span style={{ color: "red", marginLeft: "8px" }}>
                Internal Use Only!
              </span>
            )}
          </Typography>
        </Box>
        {/* Speakers */}
        {(props.video.speakers?.length && (
          <Box>
            <Typography variant="body2" sx={{
              color: "text.secondary"
            }}>
              Speaker(s): {props.video.speakers.join(", ")}
            </Typography>
          </Box>
        )) ||
          ""}
      </Stack>
      {props?.date ? (
        <Stack
          sx={{
            justifyContent: "center",
            alignItems: "end",
            minWidth: "80px"
          }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            {date}
          </Typography>
          {/* <Typography variant="body2" color="text.secondary">
            {time}
          </Typography> */}
        </Stack>
      ) : (
        ""
      )}
    </Stack>
  );
}

export default Video;
